import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useSelector } from "react-redux";
import { getConfirmedOrders } from "../Services/orderService";
import { getFranchise } from "../Services/franchiseService";
import toast from "react-hot-toast";
import { getAnalyticsOverview, getOrdersOverview } from "../Services/analyticServics";
import ThemeLoader from "./ThemeLoader";

/* ═══════════════════════════════════════════════════════════════
   DATA
═══════════════════════════════════════════════════════════════ */
// const orders = [
//   { id: 317, trackingId: "ARC000317", VppNumber: null, quantity: 1, customerName: "iqra", phoneNumber: "0316 1856167", address: "Near rasheed Photo state Zila bagh Tehsil dhirkot AJK", city: "AJK", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "returned", source: "phone", createdAt: "2026-02-18T12:26:44.000Z", updatedAt: "2026-04-02T07:54:54.000Z" },
//   { id: 316, trackingId: "ARC000316", VppNumber: "12332127", quantity: 1, customerName: "Mrs Awais", phoneNumber: "0324 4061609", address: "House no 117 Street no 5 nisbat Road Lahore", city: "Lahore", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "pending", source: "email", createdAt: "2026-02-18T12:26:44.000Z", updatedAt: "2026-03-13T11:40:26.000Z" },
//   { id: 315, trackingId: "ARC000315", VppNumber: "12332017", quantity: 2, customerName: "Umar Nasir", phoneNumber: "0345 5112860", address: "House no 18 mohalla Soan garden Islamabad", city: "Islamabad", articleName: "Lawn", amount: "4000", product: "suit", bookingAgent: "Ali", remark: "High value", is_confirmed: "confirmed", status: "returned", source: "phone", createdAt: "2026-02-19T09:10:00.000Z", updatedAt: "2026-03-14T16:00:35.000Z" },
//   { id: 314, trackingId: "ARC000314", VppNumber: "12332126", quantity: 1, customerName: "Inaam Ul Haq", phoneNumber: "0308 4381382", address: "house no P 157 street no 5 zila faisalabad", city: "Faisalabad", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "delivered", source: "phone", createdAt: "2026-02-19T11:00:00.000Z", updatedAt: "2026-03-13T11:40:15.000Z" },
//   { id: 313, trackingId: "ARC000313", VppNumber: "12332125", quantity: 1, customerName: "Muhammad Younas", phoneNumber: "0343 4009808", address: "mohalla akbar abad zila malakand", city: "Malakand", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "returned", source: "email", createdAt: "2026-02-19T13:00:00.000Z", updatedAt: "2026-03-13T11:39:55.000Z" },
//   { id: 312, trackingId: "ARC000312", VppNumber: "12332018", quantity: 1, customerName: "Farzana Younes", phoneNumber: "0341 0593879", address: "mohalla new abadi bhara kahu Islamabad", city: "Islamabad", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "pending", source: "phone", createdAt: "2026-02-20T08:00:00.000Z", updatedAt: "2026-03-13T11:15:34.000Z" },
//   { id: 311, trackingId: "ARC000311", VppNumber: "12332115", quantity: 3, customerName: "M. Ayaz", phoneNumber: "0300 4797881", address: "Muzaffar jutt street Canal road Lahore", city: "Lahore", articleName: "Linen", amount: "6000", product: "shirt", bookingAgent: "Bilal", remark: "VIP", is_confirmed: "confirmed", status: "pending", source: "phone", createdAt: "2026-02-20T10:00:00.000Z", updatedAt: "2026-03-13T11:33:04.000Z" },
//   { id: 310, trackingId: "ARC000310", VppNumber: "12332035", quantity: 1, customerName: "NaimatUllah", phoneNumber: "0322 9085987", address: "mohalla TV colony saddar Peshawar", city: "Peshawar", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "returned", source: "email", createdAt: "2026-02-20T12:00:00.000Z", updatedAt: "2026-03-14T14:47:37.000Z" },
//   { id: 309, trackingId: "ARC000309", VppNumber: "12332033", quantity: 2, customerName: "Aqil", phoneNumber: "0304 4136411", address: "block FG mohalla wafaqi colony johar town Lahore", city: "Lahore", articleName: "Khaddar", amount: "3500", product: "suit", bookingAgent: "Ali", remark: "Fragile", is_confirmed: "confirmed", status: "pending", source: "phone", createdAt: "2026-02-21T09:00:00.000Z", updatedAt: "2026-03-13T11:29:30.000Z" },
//   { id: 308, trackingId: "ARC000308", VppNumber: "12332011", quantity: 1, customerName: "Umar Daraz", phoneNumber: "0329 1289607", address: "near shandar chowk Jhelum", city: "Jhelum", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "returned", source: "phone", createdAt: "2026-02-21T11:00:00.000Z", updatedAt: "2026-03-14T15:56:39.000Z" },
//   { id: 307, trackingId: "ARC000307", VppNumber: "12332113", quantity: 1, customerName: "Khurshed Ahmed", phoneNumber: "0321 7642819", address: "near dera sain qabristan Faisalabad", city: "Faisalabad", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "pending", source: "email", createdAt: "2026-02-22T08:00:00.000Z", updatedAt: "2026-03-13T11:32:18.000Z" },
//   { id: 306, trackingId: "ARC000306", VppNumber: "12332010", quantity: 1, customerName: "Muhammad Amir", phoneNumber: "0301 8199320", address: "near bilal abad post office talagang", city: "Talagang", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "delivered", source: "phone", createdAt: "2026-02-22T10:00:00.000Z", updatedAt: "2026-03-13T11:08:51.000Z" },
//   { id: 305, trackingId: "ARC000305", VppNumber: "12332120", quantity: 2, customerName: "Zahida Bibi", phoneNumber: "0324 4213608", address: "mohalla mahfoz pore Airport road Lahore", city: "Lahore", articleName: "Chiffon", amount: "5000", product: "suit", bookingAgent: "Bilal", remark: "Express", is_confirmed: "confirmed", status: "pending", source: "phone", createdAt: "2026-02-22T14:00:00.000Z", updatedAt: "2026-03-13T11:37:13.000Z" },
//   { id: 304, trackingId: "ARC000304", VppNumber: "12332019", quantity: 1, customerName: "Ayyan Khan", phoneNumber: "0303 6192667", address: "near SNGPL sui gas office sadiqabad", city: "Sadiqabad", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "returned", source: "email", createdAt: "2026-02-23T09:00:00.000Z", updatedAt: "2026-03-13T11:33:22.000Z" },
//   { id: 303, trackingId: "ARC000303", VppNumber: "12332122", quantity: 1, customerName: "Syeda Quratulain", phoneNumber: "0370 6676570", address: "mohalla lower chatter Muzaffarabad", city: "Muzaffarabad", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "delivered", source: "phone", createdAt: "2026-02-23T11:00:00.000Z", updatedAt: "2026-03-13T11:38:44.000Z" },
//   { id: 302, trackingId: "ARC000302", VppNumber: "12332020", quantity: 1, customerName: "Sajjad Asghar", phoneNumber: "0307 7953814", address: "cinema chowk rahim yar khan", city: "Rahim Yar Khan", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "returned", source: "phone", createdAt: "2026-02-23T14:00:00.000Z", updatedAt: "2026-03-14T16:56:58.000Z" },
//   { id: 301, trackingId: "ARC000301", VppNumber: "12332110", quantity: 1, customerName: "Ishfaq Ahmed", phoneNumber: "0302 4171803", address: "mohalla badami bagh Lahore", city: "Lahore", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "returned", source: "email", createdAt: "2026-02-24T09:00:00.000Z", updatedAt: "2026-03-14T15:09:50.000Z" },
//   { id: 300, trackingId: "ARC000300", VppNumber: "12331972", quantity: 3, customerName: "Muhammad Waseem", phoneNumber: "0346 4291881", address: "block-1 sector D-11 town ship Lahore", city: "Lahore", articleName: "Cotton", amount: "7500", product: "3pc suit", bookingAgent: "Ali", remark: "VIP", is_confirmed: "confirmed", status: "delivered", source: "phone", createdAt: "2026-02-24T11:00:00.000Z", updatedAt: "2026-03-12T17:26:58.000Z" },
//   { id: 299, trackingId: "ARC000299", VppNumber: "12332024", quantity: 1, customerName: "Waheed Niazi", phoneNumber: "0326 7632654", address: "near Madina motors showroom Mianwali", city: "Mianwali", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "pending", source: "phone", createdAt: "2026-02-24T14:00:00.000Z", updatedAt: "2026-03-13T11:23:12.000Z" },
//   { id: 298, trackingId: "ARC000298", VppNumber: "12332025", quantity: 1, customerName: "Maher Zain", phoneNumber: "0329 0175455", address: "village pull nara sardar multan road muzaffargarh", city: "Muzaffargarh", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "returned", source: "email", createdAt: "2026-02-25T09:00:00.000Z", updatedAt: "2026-03-14T15:36:50.000Z" },
//   { id: 297, trackingId: "ARC000297", VppNumber: null, quantity: 1, customerName: "Arfa Noor", phoneNumber: "0312 9095491", address: "mohalla Marich mandi charsadda road Peshawar", city: "Peshawar", articleName: "Silk", amount: "3500", product: "dupatta", bookingAgent: "Bilal", remark: "Fragile", is_confirmed: "confirmed", status: "returned", source: "phone", createdAt: "2026-02-25T11:00:00.000Z", updatedAt: "2026-03-14T15:38:46.000Z" },
//   { id: 296, trackingId: "ARC000296", VppNumber: "12332027", quantity: 2, customerName: "Farah Usmani", phoneNumber: "0323 4691186", address: "mohalla lalazar phase 1 joher town Lahore", city: "Lahore", articleName: "Chiffon", amount: "5500", product: "suit", bookingAgent: "Ali", remark: "Express", is_confirmed: "confirmed", status: "delivered", source: "email", createdAt: "2026-02-25T14:00:00.000Z", updatedAt: "2026-03-13T11:25:14.000Z" },
//   { id: 295, trackingId: "ARC000295", VppNumber: "12232329", quantity: 1, customerName: "M. Shafiq", phoneNumber: "0307 4698738", address: "mohalla siddiqia colony khudian khas kasur", city: "Kasur", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "returned", source: "phone", createdAt: "2026-02-26T09:00:00.000Z", updatedAt: "2026-03-14T15:33:22.000Z" },
//   { id: 294, trackingId: "ARC000294", VppNumber: "12332032", quantity: 1, customerName: "Sheikh Muhammad Usman", phoneNumber: "0323 8856086", address: "Street No 8 Razabad Faisalabad", city: "Faisalabad", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "returned", source: "email", createdAt: "2026-02-26T11:00:00.000Z", updatedAt: "2026-03-13T11:36:06.000Z" },
//   { id: 293, trackingId: "ARC000293", VppNumber: "12331973", quantity: 1, customerName: "M. Shujaat", phoneNumber: "0347 6174564", address: "village Shakargarh District kohat tehsil lachi", city: "Kohat", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "pending", source: "phone", createdAt: "2026-02-26T14:00:00.000Z", updatedAt: "2026-03-12T17:27:18.000Z" },
//   { id: 292, trackingId: "ARC000292", VppNumber: "12331965", quantity: 2, customerName: "Hafiz Naveed", phoneNumber: "0320 0517000", address: "muhalla Rasool park main ayub road Lahore", city: "Lahore", articleName: "Khaddar", amount: "4000", product: "suit", bookingAgent: "Bilal", remark: "VIP", is_confirmed: "confirmed", status: "returned", source: "phone", createdAt: "2026-02-27T09:00:00.000Z", updatedAt: "2026-03-13T11:43:04.000Z" },
//   { id: 291, trackingId: "ARC000291", VppNumber: "12331969", quantity: 1, customerName: "Jehan Khan", phoneNumber: "0347 4429206", address: "Chak 7/1R near Post office Haroonabad", city: "Haroonabad", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "delivered", source: "email", createdAt: "2026-02-27T11:00:00.000Z", updatedAt: "2026-03-12T17:24:41.000Z" },
//   { id: 290, trackingId: "ARC000290", VppNumber: "12331968", quantity: 1, customerName: "Saud Malik", phoneNumber: "0301 6663357", address: "house no 45 Imtiaz colony near Nadra office Haroonabad", city: "Haroonabad", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "pending", source: "phone", createdAt: "2026-02-27T14:00:00.000Z", updatedAt: "2026-03-12T17:24:14.000Z" },
//   { id: 289, trackingId: "ARC000289", VppNumber: "12232328", quantity: 1, customerName: "Wasif Shabir", phoneNumber: "0315 5856230", address: "Muhalla Allama iqbal colony Peoples colony road Rawalpindi", city: "Rawalpindi", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "delivered", source: "email", createdAt: "2026-02-28T09:00:00.000Z", updatedAt: "2026-03-13T08:10:40.000Z" },
//   { id: 288, trackingId: "ARC000288", VppNumber: "12232332", quantity: 1, customerName: "Asghar Ali", phoneNumber: "0314 9163056", address: "near Al Barkat oil change jehangira road Sawabi", city: "Sawabi", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "returned", source: "phone", createdAt: "2026-02-28T11:00:00.000Z", updatedAt: "2026-03-14T17:09:54.000Z" },
//   { id: 287, trackingId: "ARC000287", VppNumber: "12232323", quantity: 1, customerName: "Atta Muhammad", phoneNumber: "0315 3997894", address: "Muhalla housing society sanghar", city: "Sanghar", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "returned", source: "email", createdAt: "2026-03-01T09:00:00.000Z", updatedAt: "2026-03-14T15:07:52.000Z" },
//   { id: 286, trackingId: "ARC000286", VppNumber: null, quantity: 2, customerName: "Amir Mehmood", phoneNumber: "0332 5334392", address: "sector D 17/2 mohalla Margalla view Islamabad", city: "Islamabad", articleName: "Cotton", amount: "4500", product: "shirt", bookingAgent: "Ali", remark: "Express", is_confirmed: "confirmed", status: "delivered", source: "phone", createdAt: "2026-03-01T11:00:00.000Z", updatedAt: "2026-03-14T14:42:42.000Z" },
//   { id: 285, trackingId: "ARC000285", VppNumber: "12331959", quantity: 1, customerName: "Zohaib Goraya", phoneNumber: "0346 6923112", address: "near Narowal Bazar new lahore road Narowal", city: "Narowal", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "delivered", source: "phone", createdAt: "2026-03-01T14:00:00.000Z", updatedAt: "2026-03-12T17:12:38.000Z" },
//   { id: 284, trackingId: "ARC000284", VppNumber: "12232327", quantity: 1, customerName: "M. Yaseen", phoneNumber: "0310 3312114", address: "near main bazar khall chitral road Dir Lower", city: "Dir Lower", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "returned", source: "email", createdAt: "2026-03-02T09:00:00.000Z", updatedAt: "2026-03-19T16:47:21.000Z" },
//   { id: 283, trackingId: "ARC000283", VppNumber: "12332022", quantity: 1, customerName: "Agha Kamran", phoneNumber: "0300 5090259", address: "mohalla tapali street chatri chowk khairpur", city: "Khairpur", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "returned", source: "phone", createdAt: "2026-03-02T11:00:00.000Z", updatedAt: "2026-03-13T11:18:57.000Z" },
//   { id: 282, trackingId: "ARC000282", VppNumber: "12232325", quantity: 1, customerName: "Kashif Mehmood", phoneNumber: "0300 4018536", address: "khan manzil Street no 5 near islamia park Wazirabad", city: "Wazirabad", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "returned", source: "phone", createdAt: "2026-03-02T14:00:00.000Z", updatedAt: "2026-03-14T17:09:00.000Z" },
//   { id: 281, trackingId: "ARC000281", VppNumber: "12232319", quantity: 1, customerName: "Awais Mir", phoneNumber: "0346 1085107", address: "ward no 20 mohalla chella bandi Muzaffarabad", city: "Muzaffarabad", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "returned", source: "email", createdAt: "2026-03-03T09:00:00.000Z", updatedAt: "2026-03-19T17:35:06.000Z" },
//   { id: 280, trackingId: "ARC000280", VppNumber: "12232320", quantity: 1, customerName: "Muhammad Sufyan", phoneNumber: "0313 5767455", address: "mohalla gharibabad Near doctor medical center Swabi", city: "Swabi", articleName: "Lawn", amount: "2000", product: "suit", bookingAgent: "-", remark: "High value", is_confirmed: "confirmed", status: "returned", source: "phone", createdAt: "2026-03-03T11:00:00.000Z", updatedAt: "2026-04-09T05:19:07.000Z" },
// ];

/* ═══════════════════════════════════════════════════════════════
   COMPUTED ANALYTICS
═══════════════════════════════════════════════════════════════ */
function useAnalytics(orders) {
  return useMemo(() => {
    const total = orders.length;
    const delivered = orders.filter(o => o.status === "delivered");
    const pending = orders.filter(o => o.status === "pending");
    const returned = orders.filter(o => o.status === "returned");
    const cancelled = orders.filter(o => o.status === "cancelled");
    const revenue = delivered.reduce((s, o) => s + parseInt(o.amount), 0);
    const totalRevenue = orders.reduce((s, o) => s + parseInt(o.amount), 0);
    const avgOrderValue = totalRevenue / total;
    const deliveryRate = ((delivered.length / total) * 100).toFixed(1);
    const returnRate = ((returned.length / total) * 100).toFixed(1);
    const uniqueCustomers = new Set(orders.map(o => o.customerName.toLowerCase())).size;

    // By city
    const cityMap = {};
    orders.forEach(o => {
      const c = o.city || "Unknown";
      cityMap[c] = (cityMap[c] || 0) + 1;
    });
    const byCity = Object.entries(cityMap).sort((a, b) => b[1] - a[1]);

    // By status
    const byStatus = [
      { name: "Delivered", value: delivered.length, color: "#10b981" },
      { name: "Pending", value: pending.length, color: "#f59e0b" },
      { name: "Returned", value: returned.length, color: "#ef4444" },
      { name: "Cancelled", value: cancelled.length, color: "#6b7280" },
    ];

    // By product
    const prodMap = {};
    orders.forEach(o => { prodMap[o.articleName] = (prodMap[o.articleName] || 0) + 1; });
    const byProduct = Object.entries(prodMap).sort((a, b) => b[1] - a[1]);

    // By source
    const srcMap = {};
    orders.forEach(o => { const s = o.source || "phone"; srcMap[s] = (srcMap[s] || 0) + 1; });
    const bySource = Object.entries(srcMap);

    // Daily trend (by date)
    const dayMap = {};
    orders.forEach(o => {
      const d = o.createdAt.split("T")[0];
      if (!dayMap[d]) dayMap[d] = { date: d, orders: 0, revenue: 0, delivered: 0, returned: 0 };
      dayMap[d].orders++;
      dayMap[d].revenue += parseInt(o.amount);
      if (o.status === "delivered") dayMap[d].delivered++;
      if (o.status === "returned") dayMap[d].returned++;
    });
    const dailyTrend = Object.values(dayMap).sort((a, b) => a.date.localeCompare(b.date));

    // By agent
    const agentMap = {};

    orders.forEach((o) => {
      const ag = o.bookingAgent === "-" ? "Direct" : o.bookingAgent;

      if (!agentMap[ag]) {
        agentMap[ag] = {
          name: ag,
          orders: 0,
          revenue: 0,
          delivered: 0,
          returned: 0, // ✅ added
        };
      }

      agentMap[ag].orders++;
      agentMap[ag].revenue += parseInt(o.amount || 0);

      if (o.status === "delivered") {
        agentMap[ag].delivered++;
      }

      if (o.status === "returned") {
        agentMap[ag].returned++; // ✅ added
      }
    });

    const byAgent = Object.values(agentMap).sort(
      (a, b) => b.orders - a.orders
    );


    // Top customers by amount
    const custMap = {};
    orders.forEach(o => {
      const k = o.phoneNumber;
      if (!custMap[k]) custMap[k] = {
        name: o.customerName, orders: 0, amount: 0, city: o.city,
        delivered: 0,
        returned: 0,
      };


      if (o.status === "delivered") {
        custMap[k].delivered++;
      }

      if (o.status === "returned") {
        custMap[k].returned++;
      }

      custMap[k].orders++;

      // custMap[k].amount += parseInt(o.amount);
    });
    const topCustomers = Object.values(custMap).sort((a, b) => b.amount - a.amount).slice(0, 8);


    // Revenue by city
    const cityRevMap = {};
    orders.forEach(o => {
      const c = o.city || "Unknown";
      cityRevMap[c] = (cityRevMap[c] || 0) + parseInt(o.amount);
    });
    const revenueByCity = Object.entries(cityRevMap).sort((a, b) => b[1] - a[1]).slice(0, 8);

    // Weekly data (group by week)
    const weekMap = {};
    orders.forEach(o => {
      const d = new Date(o.createdAt);
      const week = `W${Math.ceil(d.getDate() / 7)} ${d.toLocaleString("default", { month: "short" })}`;
      if (!weekMap[week]) weekMap[week] = { week, orders: 0, revenue: 0 };
      weekMap[week].orders++;
      weekMap[week].revenue += parseInt(o.amount);
    });
    const weeklyTrend = Object.values(weekMap);

    // Pending > 7 days alerts
    const now = new Date();
    const stalePending = pending.filter(o => (now - new Date(o.createdAt)) / 86400000 > 7);

    // Pending with no VPP
    const noVpp = pending.filter(o => !o.VppNumber);

    return {
      total, delivered: delivered.length, pending: pending.length,
      returned: returned.length, cancelled: cancelled.length,
      revenue, totalRevenue, avgOrderValue, deliveryRate, returnRate,
      uniqueCustomers, byCity, byStatus, byProduct, bySource,
      dailyTrend, byAgent, topCustomers, revenueByCity, weeklyTrend,
      stalePending, noVpp,
      pendingOrders: pending,
    };
  }, [orders]);
}

/* ═══════════════════════════════════════════════════════════════
   ECHARTS HOOK
═══════════════════════════════════════════════════════════════ */
// function useECharts(ref, optionFn, deps) {
//   useEffect(() => {
//     if (!ref.current || !window.echarts) return;
//     const chart = window.echarts.init(ref.current, null, { renderer: "canvas" });
//     chart.setOption(optionFn());
//     const ro = new ResizeObserver(() => chart.resize());
//     ro.observe(ref.current);
//     return () => { chart.dispose(); ro.disconnect(); };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, deps);
// }

function useECharts(ref, optionFn, deps) {
  useEffect(() => {
    if (!ref.current || !window.echarts) return;

    const chart = window.echarts.init(ref.current, null, {
      renderer: "canvas"
    });

    chart.setOption(optionFn());

    const handleResize = () => {
      chart.resize();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      chart.dispose();
    };
  }, deps);
}

/* ═══════════════════════════════════════════════════════════════
   ANIMATED COUNTER
═══════════════════════════════════════════════════════════════ */
function AnimCount({ target, prefix = "", suffix = "", decimals = 0, duration = 1400 }) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    const start = performance.now();
    const frame = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const ease = 1 - Math.pow(1 - p, 3);
      setVal(parseFloat((ease * target).toFixed(decimals)));
      if (p < 1) requestAnimationFrame(frame);
    };
    requestAnimationFrame(frame);
  }, [target, duration, decimals]);
  return <>{prefix}{decimals > 0 ? val.toFixed(decimals) : Math.round(val).toLocaleString()}{suffix}</>;
}

/* ═══════════════════════════════════════════════════════════════
   TICKER
═══════════════════════════════════════════════════════════════ */
function AlertTicker({ alerts }) {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx(i => (i + 1) % alerts.length), 4000);
    return () => clearInterval(t);
  }, [alerts.length]);
  if (!alerts.length) return null;
  const a = alerts[idx];
  return (
    <div style={{
      background: "linear-gradient(90deg,rgba(239,68,68,0.15),rgba(245,158,11,0.08))",
      border: "1px solid rgba(239,68,68,0.3)",
      borderRadius: 8, padding: "9px 18px",
      display: "flex", alignItems: "center", gap: 12,
      overflow: "hidden", position: "relative"
    }}>
      <span style={{ fontSize: 13, fontWeight: 700, color: "#ef4444", flexShrink: 0, letterSpacing: 1 }}>⚡ ALERT</span>
      <div style={{ width: 1, height: 16, background: "rgba(239,68,68,0.4)" }} />
      <span style={{
        fontSize: 13, color: "#fca5a5",
        animation: "tickerSlide 0.4s ease",
        display: "inline-block", flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"
      }} key={idx}>
        {a.icon} {a.text}
      </span>
      <span style={{ fontSize: 11, color: "rgba(239,68,68,0.5)", flexShrink: 0 }}>{idx + 1}/{alerts.length}</span>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════
   KPI TILE
═══════════════════════════════════════════════════════════════ */
function KPITile({ icon, label, value, sub, color, trend, prefix = "", suffix = "", decimals = 0, delay = 0 }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => { setTimeout(() => setVisible(true), delay); }, [delay]);
  return (
    <div style={{
      background: "var(--surface)", border: "1px solid var(--border)",
      borderRadius: 16, padding: "22px 22px 18px",
      position: "relative", overflow: "hidden",
      transform: visible ? "translateY(0)" : "translateY(20px)",
      opacity: visible ? 1 : 0,
      transition: "transform 0.5s ease, opacity 0.5s ease",
      cursor: "default",
    }}
      onMouseEnter={e => { e.currentTarget.style.borderColor = color + "55"; e.currentTarget.style.transform = "translateY(-3px)"; }}
      onMouseLeave={e => { e.currentTarget.style.borderColor = "var(--border)"; e.currentTarget.style.transform = "translateY(0)"; }}
    >
      {/* glow blob */}
      <div style={{ position: "absolute", top: -30, right: -30, width: 100, height: 100, borderRadius: "50%", background: color, opacity: 0.1, filter: "blur(24px)", pointerEvents: "none" }} />
      {/* top bar accent */}
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 2, background: color, opacity: 0.7, borderRadius: "16px 16px 0 0" }} />

      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 10 }}>
        <div style={{ fontSize: 22 }}>{icon}</div>
        {trend !== undefined && (
          <div style={{
            fontSize: 11, fontWeight: 700, padding: "3px 8px", borderRadius: 12,
            background: trend >= 0 ? "rgba(16,185,129,0.15)" : "rgba(239,68,68,0.15)",
            color: trend >= 0 ? "#10b981" : "#ef4444"
          }}>
            {trend >= 0 ? "▲" : "▼"} {Math.abs(trend)}%
          </div>
        )}
      </div>
      <div style={{ fontFamily: "'Syne',sans-serif", fontSize: 30, fontWeight: 800, color, lineHeight: 1, marginBottom: 4 }}>
        {visible ? <AnimCount target={typeof value === "string" ? parseFloat(value) : value} prefix={prefix} suffix={suffix} decimals={decimals} /> : "—"}
      </div>
      <div style={{ fontSize: 11, letterSpacing: 1.3, textTransform: "uppercase", color: "var(--text-muted)", marginBottom: 4 }}>{label}</div>
      {sub && <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 2 }}>{sub}</div>}
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════
   SECTION HEADER
═══════════════════════════════════════════════════════════════ */
function SectionTitle({ children, sub }) {
  return (
    <div style={{ marginBottom: 16 }}>
      <h3 style={{ fontFamily: "'Syne',sans-serif", fontSize: 16, fontWeight: 700, color: "var(--text)", margin: 0 }}>{children}</h3>
      {sub && <p style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 3 }}>{sub}</p>}
    </div>
  );
}

function Card({ children, style = {} }) {
  return (
    <div style={{
      background: "var(--surface)", border: "1px solid var(--border)",
      borderRadius: 14, padding: "20px 22px", ...style
    }}>
      {children}
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════
   CHART COMPONENTS
═══════════════════════════════════════════════════════════════ */
const CHART_DEFAULTS = {
  backgroundColor: "transparent",
  textStyle: { fontFamily: "'DM Sans',sans-serif", color: "#6b7280" },
  grid: { left: 16, right: 16, top: 16, bottom: 0, containLabel: true },
  tooltip: {
    backgroundColor: "#181c24",
    borderColor: "rgba(255,255,255,0.1)",
    borderWidth: 1,
    textStyle: { color: "#e8eaf0", fontFamily: "'DM Sans',sans-serif", fontSize: 12 },
  },
};

function StatusDonut({ data }) {
  const ref = useRef();
  useECharts(ref, () => ({
    ...CHART_DEFAULTS,
    tooltip: { ...CHART_DEFAULTS.tooltip, trigger: "item", formatter: "{b}: {c} ({d}%)" },
    legend: { show: false },
    series: [{
      type: "pie", radius: ["55%", "80%"], center: ["50%", "50%"],
      itemStyle: { borderRadius: 6, borderColor: "#111318", borderWidth: 3 },
      label: { show: false },
      emphasis: { scale: true, scaleSize: 6 },
      data: data.map(d => ({ name: d.name, value: d.value, itemStyle: { color: d.color } })),
    }],
  }), [data]);
  return <div ref={ref} style={{ height: 200 }} />;
}

function DailyLineChart({ data }) {
  const ref = useRef();
  useECharts(ref, () => ({
    ...CHART_DEFAULTS,
    grid: { left: 8, right: 8, top: 20, bottom: 0, containLabel: true },
    tooltip: { ...CHART_DEFAULTS.tooltip, trigger: "axis" },
    xAxis: {
      type: "category", data: data.map(d => d.date.slice(5)),
      axisLine: { lineStyle: { color: "rgba(255,255,255,0.08)" } },
      axisTick: { show: false }, axisLabel: { color: "#4b5563", fontSize: 10 },
    },
    yAxis: { type: "value", axisLabel: { color: "#4b5563", fontSize: 10 }, splitLine: { lineStyle: { color: "rgba(255,255,255,0.05)" } } },
    series: [
      {
        name: "Orders", type: "line", smooth: true, data: data.map(d => d.orders),
        lineStyle: { color: "#6366f1", width: 2 },
        itemStyle: { color: "#6366f1" },
        areaStyle: { color: { type: "linear", x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: "rgba(99,102,241,0.3)" }, { offset: 1, color: "rgba(99,102,241,0.01)" }] } },
        symbol: "circle", symbolSize: 5,
      },
      {
        name: "Delivered", type: "line", smooth: true, data: data.map(d => d.delivered),
        lineStyle: { color: "#10b981", width: 2 },
        itemStyle: { color: "#10b981" },
        symbol: "circle", symbolSize: 4,
      },
      {
        name: "Returned", type: "line", smooth: true, data: data.map(d => d.returned),
        lineStyle: { color: "#ef4444", width: 2, type: "dashed" },
        itemStyle: { color: "#ef4444" },
        symbol: "circle", symbolSize: 4,
      },
    ],
  }), [data]);
  return <div ref={ref} style={{ height: 220 }} />;
}
function CityBarChart({ data }) {
  const ref = useRef();

  useECharts(ref, () => ({
    ...CHART_DEFAULTS,
    grid: { left: 8, right: 20, top: 8, bottom: 0, containLabel: true },
    tooltip: {
      ...CHART_DEFAULTS.tooltip,
      trigger: "axis",
      axisPointer: { type: "shadow" }
    },
    xAxis: {
      type: "value",
      axisLabel: { color: "#4b5563", fontSize: 10 },
      splitLine: {
        lineStyle: { color: "rgba(255,255,255,0.05)" }
      }
    },
    yAxis: {
      type: "category",
      data: data.map(d => d.city).reverse(),
      axisLabel: { color: "#9ca3af", fontSize: 11 },
      axisLine: { show: false },
      axisTick: { show: false }
    },
    series: [
      {
        type: "bar",
        data: data.map(d => d.totalOrders).reverse(),
        barMaxWidth: 18,
        borderRadius: [0, 6, 6, 0],
        itemStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 1,
            y2: 0,
            colorStops: [
              { offset: 0, color: "#6366f1" },
              { offset: 1, color: "#a78bfa" }
            ]
          }
        },
        label: {
          show: true,
          position: "right",
          color: "#6b7280",
          fontSize: 10
        }
      }
    ]
  }), [data]);

  return <div ref={ref} style={{ height: 280 }} />;
}

function ProductPieChart({ data }) {
  const ref = useRef();
  const colors = ["#6366f1", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6", "#06b6d4", "#ec4899"];
  useECharts(ref, () => ({
    ...CHART_DEFAULTS,
    tooltip: { ...CHART_DEFAULTS.tooltip, trigger: "item", formatter: "{b}: {c} ({d}%)" },
    legend: { orient: "vertical", right: 0, top: "center", textStyle: { color: "#6b7280", fontSize: 11 }, icon: "circle", itemWidth: 8 },
    series: [{
      type: "pie", radius: ["45%", "70%"], center: ["40%", "50%"],
      itemStyle: { borderRadius: 4, borderColor: "#111318", borderWidth: 2 },
      label: { show: false },
      data: data.map((d, i) => ({ name: d[0], value: d[1], itemStyle: { color: colors[i % colors.length] } })),
    }],
  }), [data]);
  return <div ref={ref} style={{ height: 200 }} />;
}

function SourceChart({ data }) {
  const ref = useRef();
  const colors = { phone: "#6366f1", email: "#10b981", manual: "#f59e0b" };
  const icons = { phone: "📞", email: "✉️", manual: "✎" };
  useECharts(ref, () => ({
    ...CHART_DEFAULTS,
    tooltip: { ...CHART_DEFAULTS.tooltip, trigger: "item", formatter: "{b}: {c}" },
    series: [{
      type: "pie", radius: ["50%", "75%"],
      center: ["50%", "50%"],
      itemStyle: { borderRadius: 6, borderColor: "#111318", borderWidth: 3 },
      label: { show: true, color: "#9ca3af", fontSize: 11, formatter: (p) => `${icons[p.name] || ""} ${p.name}\n${p.percent.toFixed(0)}%` },
      labelLine: { lineStyle: { color: "rgba(255,255,255,0.1)" } },
      data: data.map(d => ({ name: d[0], value: d[1], itemStyle: { color: colors[d[0]] || "#6b7280" } })),
    }],
  }), [data]);
  return <div ref={ref} style={{ height: 200 }} />;
}

function RevenueCityChart({ data }) {
  const ref = useRef();

  useECharts(
    ref,
    () => ({
      ...CHART_DEFAULTS,
      grid: {
        left: 8,
        right: 20,
        top: 8,
        bottom: 0,
        containLabel: true,
      },

      tooltip: {
        ...CHART_DEFAULTS.tooltip,
        trigger: "axis",
        axisPointer: { type: "shadow" },
        formatter: (params) => {
          const item = params[0];
          return `${item.name}<br/>PKR ${Number(item.value).toLocaleString()}`;
        },
      },

      xAxis: {
        type: "value",
        axisLabel: {
          color: "#4b5563",
          fontSize: 10,
          formatter: (v) => `${(v / 1000).toFixed(0)}k`,
        },
        splitLine: {
          lineStyle: { color: "rgba(255,255,255,0.05)" },
        },
      },

      yAxis: {
        type: "category",
        data: data.map((d) => d.city).reverse(),
        axisLabel: {
          color: "#9ca3af",
          fontSize: 11,
        },
        axisLine: { show: false },
        axisTick: { show: false },
      },

      series: [
        {
          type: "bar",
          data: data.map((d) => d.revenue).reverse(),
          barMaxWidth: 18,
          borderRadius: [0, 6, 6, 0],

          itemStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 1,
              y2: 0,
              colorStops: [
                { offset: 0, color: "#10b981" },
                { offset: 1, color: "#6ee7b7" },
              ],
            },
          },

          label: {
            show: true,
            position: "right",
            color: "#6b7280",
            fontSize: 10,
            formatter: ({ value }) =>
              `PKR ${Number(value).toLocaleString()}`,
          },
        },
      ],
    }),
    [data]
  );

  return <div ref={ref} style={{ height: 260 }} />;
}

function WeeklyBarChart({ data }) {
  const ref = useRef();
  useECharts(ref, () => ({
    ...CHART_DEFAULTS,
    grid: { left: 8, right: 8, top: 20, bottom: 0, containLabel: true },
    tooltip: { ...CHART_DEFAULTS.tooltip, trigger: "axis", axisPointer: { type: "shadow" } },
    legend: { textStyle: { color: "#6b7280", fontSize: 11 }, top: 0 },
    xAxis: { type: "category", data: data.map(d => d.week), axisLabel: { color: "#4b5563", fontSize: 10 }, axisTick: { show: false }, axisLine: { lineStyle: { color: "rgba(255,255,255,0.08)" } } },
    yAxis: [
      { type: "value", name: "Orders", nameTextStyle: { color: "#4b5563", fontSize: 10 }, axisLabel: { color: "#4b5563", fontSize: 10 }, splitLine: { lineStyle: { color: "rgba(255,255,255,0.05)" } } },
      { type: "value", name: "Revenue", nameTextStyle: { color: "#4b5563", fontSize: 10 }, axisLabel: { color: "#4b5563", fontSize: 10, formatter: v => `${(v / 1000).toFixed(0)}k` }, splitLine: { show: false } },
    ],
    series: [
      { name: "Orders", type: "bar", data: data.map(d => d.orders), barMaxWidth: 24, borderRadius: [4, 4, 0, 0], itemStyle: { color: "rgba(99,102,241,0.7)" } },
      { name: "Revenue (PKR)", type: "line", yAxisIndex: 1, smooth: true, data: data.map(d => d.revenue), lineStyle: { color: "#f59e0b", width: 2 }, itemStyle: { color: "#f59e0b" }, symbol: "circle", symbolSize: 5 },
    ],
  }), [data]);
  return <div ref={ref} style={{ height: 220 }} />;
}

function DeliveryGauge({ rate }) {
  const ref = useRef();
  useECharts(ref, () => ({
    ...CHART_DEFAULTS,
    series: [{
      type: "gauge",
      startAngle: 200, endAngle: -20,
      min: 0, max: 100,
      radius: "90%",
      center: ["50%", "60%"],
      pointer: { show: true, length: "55%", width: 4, itemStyle: { color: "#6366f1" } },
      progress: { show: true, width: 12, itemStyle: { color: { type: "linear", x: 0, y: 0, x2: 1, y2: 0, colorStops: [{ offset: 0, color: "#6366f1" }, { offset: 1, color: "#10b981" }] } } },
      axisLine: { lineStyle: { width: 12, color: [[1, "rgba(255,255,255,0.06)"]] } },
      axisTick: { show: false },
      splitLine: { show: false },
      axisLabel: { show: false },
      detail: { valueAnimation: true, formatter: "{value}%", color: "#e8eaf0", fontFamily: "'Syne',sans-serif", fontSize: 22, fontWeight: 800, offsetCenter: [0, "20%"] },
      title: { offsetCenter: [0, "45%"], color: "#6b7280", fontSize: 11 },
      data: [{ value: parseFloat(rate), name: "Delivery Rate" }],
    }],
  }), [rate]);
  return <div ref={ref} style={{ height: 180 }} />;
}

function ReturnRateRadar({ data }) {
  const ref = useRef();
  useECharts(ref, () => ({
    ...CHART_DEFAULTS,
    radar: {
      indicator: [
        { name: "Lahore", max: 10 }, { name: "Islamabad", max: 10 },
        { name: "Faisalabad", max: 10 }, { name: "Peshawar", max: 10 },
        { name: "Rawalpindi", max: 10 },
      ],
      axisName: { color: "#6b7280", fontSize: 10 },
      splitLine: { lineStyle: { color: "rgba(255,255,255,0.06)" } },
      splitArea: { show: false },
      axisLine: { lineStyle: { color: "rgba(255,255,255,0.08)" } },
    },
    series: [{
      type: "radar",
      data: [
        { value: data.slice(0, 5).map(d => d[1]), name: "Orders", areaStyle: { color: "rgba(99,102,241,0.15)" }, lineStyle: { color: "#6366f1" }, itemStyle: { color: "#6366f1" } },
      ],
    }],
  }), [data]);
  return <div ref={ref} style={{ height: 200 }} />;
}

/* ═══════════════════════════════════════════════════════════════
   SCROLLING MARQUEE TICKER
═══════════════════════════════════════════════════════════════ */
function DataMarquee({ items }) {
  return (
    <div style={{ overflow: "hidden", borderTop: "1px solid var(--border)", borderBottom: "1px solid var(--border)", background: "var(--surface)", padding: "8px 0", position: "relative" }}>
      <div style={{ display: "flex", gap: 0, animation: "marquee 30s linear infinite", whiteSpace: "nowrap", width: "max-content" }}>
        {[...items, ...items].map((item, i) => (
          <span key={i} style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "0 32px", fontSize: 12, color: item.color || "var(--text-muted)", borderRight: "1px solid var(--border)" }}>
            <span>{item.icon}</span>
            <span style={{ fontWeight: 600, color: "var(--text-dim)" }}>{item.label}:</span>
            <span style={{ fontFamily: "'Syne',sans-serif", fontWeight: 700, color: item.color || "var(--accent)" }}>{item.value}</span>
          </span>
        ))}
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════
   PROGRESS BAR
═══════════════════════════════════════════════════════════════ */
function ProgressBar({ label, value, max, color = "#6366f1", sub }) {
  const pct = Math.round((value / max) * 100);
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
        <span style={{ fontSize: 13, fontWeight: 500, color: "var(--text-dim)" }}>{label}</span>
        <span style={{ fontSize: 12, color: "var(--text-muted)" }}>{value} <span style={{ opacity: 0.5 }}>({pct}%)</span></span>
      </div>
      <div style={{ height: 6, background: "rgba(255,255,255,0.05)", borderRadius: 6, overflow: "hidden" }}>
        <div style={{ height: "100%", width: `${pct}%`, background: color, borderRadius: 6, transition: "width 1s ease", boxShadow: `0 0 8px ${color}66` }} />
      </div>
      {sub && <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 3 }}>{sub}</div>}
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════
   MAIN DASHBOARD
═══════════════════════════════════════════════════════════════ */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
:root{
  --bg:#080b10;
  --surface:#0f1318;
  --surface2:#161b23;
  --border:rgba(255,255,255,0.06);
  --border-hover:rgba(255,255,255,0.12);
  --text:#e2e8f0;
  --text-muted:#4b5563;
  --text-dim:#9ca3af;
  --accent:#6366f1;
  --accent-soft:rgba(99,102,241,0.15);
  --green:#10b981;
  --gold:#f59e0b;
  --red:#ef4444;
  --radius:14px;
}
body{background:var(--bg);}
.dash{font-family:'DM Sans',sans-serif;background:var(--bg);color:var(--text);min-height:100vh;}
.dash-inner{max-width:1600px;margin:0 auto;padding:0 28px 60px;}

/* TOP NAV */
.top-nav{
  background:rgba(8,11,16,0.85);
  backdrop-filter:blur(16px);
  border-bottom:1px solid var(--border);
  position:sticky;top:0;z-index:0;
  padding:0 28px;
}

.oms-content{
padding :0px !important;}
.top-nav-inner{max-width:1600px;margin:0 auto;display:flex;align-items:center;gap:20px;height:60px;}
.logo{font-family:'Syne',sans-serif;font-weight:800;font-size:20px;color:#fff;letter-spacing:-0.5px;}
.logo span{color:var(--accent);}
.nav-links{display:flex;gap:4px;margin-left:24px;}
.nav-link{padding:6px 14px;border-radius:8px;font-size:13px;font-weight:500;color:var(--text-muted);cursor:pointer;transition:all .18s;}
.nav-link:hover{background:var(--surface2);color:var(--text);}
.nav-link.active{background:var(--accent-soft);color:var(--accent);}
.top-right{margin-left:auto;display:flex;align-items:center;gap:10px;}
.now-badge{font-size:12px;color:var(--text-muted);background:var(--surface);border:1px solid var(--border);padding:5px 12px;border-radius:20px;}
.dot-live{display:inline-block;width:6px;height:6px;border-radius:50%;background:#10b981;margin-right:6px;animation:pulse 1.5s infinite;}

/* SECTIONS */
.section{margin-bottom:28px;}
.grid-2{display:grid;grid-template-columns:repeat(2,1fr);gap:20px;}
.grid-3{display:grid;grid-template-columns:repeat(3,1fr);gap:20px;}
.grid-4{display:grid;grid-template-columns:repeat(4,1fr);gap:16px;}
.grid-2-1{display:grid;grid-template-columns:2fr 1fr;gap:20px;}
.grid-1-2{display:grid;grid-template-columns:1fr 2fr;gap:20px;}
.grid-3-2{display:grid;grid-template-columns:3fr 2fr;gap:20px;}

/* TABLE */
.data-table{width:100%;border-collapse:collapse;}
.data-table th{padding:10px 14px;text-align:left;font-size:10.5px;letter-spacing:1.2px;text-transform:uppercase;color:var(--text-muted);font-weight:600;border-bottom:1px solid var(--border);}
.data-table td{padding:11px 14px;font-size:13px;border-bottom:1px solid rgba(255,255,255,0.03);vertical-align:middle;}
.data-table tbody tr:hover{background:rgba(255,255,255,0.02);}
.data-table tbody tr:last-child td{border-bottom:none;}

/* BADGE */
.badge{display:inline-flex;align-items:center;gap:4px;padding:3px 9px;border-radius:20px;font-size:11px;font-weight:600;}

/* RANK NUMBER */
.rank{width:26px;height:26px;border-radius:50%;background:var(--surface2);border:1px solid var(--border);display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;color:var(--text-muted);flex-shrink:0;}
.rank.gold{background:rgba(245,158,11,0.15);border-color:rgba(245,158,11,0.4);color:var(--gold);}
.rank.silver{background:rgba(148,163,184,0.1);border-color:rgba(148,163,184,0.3);color:#94a3b8;}
.rank.bronze{background:rgba(180,83,9,0.1);border-color:rgba(180,83,9,0.3);color:#b45309;}

/* KPI SCORE CARD */
.score-ring{position:relative;display:flex;align-items:center;justify-content:center;}

/* ALERT ROW */
.alert-row{display:flex;align-items:center;gap:10px;padding:9px 12px;border-radius:8px;background:rgba(239,68,68,0.07);border:1px solid rgba(239,68,68,0.15);margin-bottom:8px;font-size:12px;}
.alert-row:last-child{margin-bottom:0;}

/* ANIMATIONS */
@keyframes pulse{0%,100%{opacity:1;}50%{opacity:0.3;}}
@keyframes marquee{0%{transform:translateX(0);}100%{transform:translateX(-50%);}}
@keyframes tickerSlide{from{opacity:0;transform:translateY(6px);}to{opacity:1;transform:translateY(0);}}
@keyframes fadeUp{from{opacity:0;transform:translateY(16px);}to{opacity:1;transform:translateY(0);}}
@keyframes shimmer{0%{background-position:-400px 0;}100%{background-position:400px 0;}}

.fade-up{animation:fadeUp 0.5s ease both;}
`;

const STATUS_CFG = {
  delivered: { color: "#10b981", bg: "rgba(16,185,129,0.12)", label: "Delivered", icon: "✓" },
  pending: { color: "#f59e0b", bg: "rgba(245,158,11,0.12)", label: "Pending", icon: "⏳" },
  returned: { color: "#ef4444", bg: "rgba(239,68,68,0.12)", label: "Returned", icon: "↩" },
  cancelled: { color: "#6b7280", bg: "rgba(107,114,128,0.12)", label: "Cancelled", icon: "✕" },
};

export default function OrderOverviewDashboard() {
  const [activeNav, setActiveNav] = useState("dashboard");
  const [echartsLoaded, setEchartsLoaded] = useState(false);
  const [now, setNow] = useState(new Date());
  const [analyticsOverview, setAnalyticsOverview] = useState(null);



  const [orders, setOrders] = useState([]);
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({
    status: "all",
    from: "",
    to: "",
    trackingId: "",
  });
  const [loading, setLoading] = useState(false);
  const [filterType, setFilterType] = useState("today");
  const [company, setCompany] = useState("");

  const [franchises, setFranchises] = useState([])
  const role = useSelector((state) => state.auth.role);
  // ✅ Safe base64 conversion

  const companyPin = useSelector(state => state.auth.companyPin);

  const base64Pin = useMemo(() => {
    return companyPin ? btoa(companyPin) : "";
  }, [companyPin]);

  const base64Company = useMemo(() => {
    return company ? btoa(company) : "";
  }, [company]);


  const companyPinToSend =
    role === "superAdmin" ? base64Company : base64Pin;


  const getDateRangeByFilter = (type) => {
    const now = new Date();

    let from = "";
    let to = now.toISOString().split("T")[0]; // today

    switch (type) {
      case "day":
        from = to;
        break;

      case "week":
        const firstDayOfWeek = new Date(now);
        firstDayOfWeek.setDate(now.getDate() - now.getDay());
        from = firstDayOfWeek.toISOString().split("T")[0];
        break;

      case "month":
        const firstDayOfMonth = new Date(
          now.getFullYear(),
          now.getMonth(),
          1
        );
        from = firstDayOfMonth.toISOString().split("T")[0];
        break;

      case "year":
        const firstDayOfYear = new Date(
          now.getFullYear(),
          0,
          1
        );
        from = firstDayOfYear.toISOString().split("T")[0];
        break;

      case "all":
      default:
        from = "";
        to = "";
        break;
    }

    return { from, to };
  };


  const fetchOrders = useCallback(async () => {
    if (role === "superAdmin" && !base64Company)
      return;
    if (role !== "superAdmin" && !base64Pin)
      return;
    try {
      setLoading(true);
      const dateRange = getDateRangeByFilter(filterType);
      const payload = { page, company_pin: role === "superAdmin" ? base64Company : base64Pin, is_confirmed: "confirmed", };
      if (filters.status !== "all") { payload.status = filters.status; }
      if (filters.trackingId) { payload.trackingId = filters.trackingId; }
      if (dateRange.from) { payload.from = dateRange.from; }
      if (dateRange.to) { payload.to = dateRange.to; }
      console.log("API Payload:", payload);
      const res = await getConfirmedOrders(payload);
      if (res?.status === "success") {
        setOrders(res.data || []);
      }
      else { setOrders([]); }
    }
    catch (error) {
      console.log(error); setOrders([]);
    } finally { setLoading(false); }

  }, [page, filters, filterType, role, base64Pin, base64Company]);


  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);


  // ✅ Analytics
  const analytics = useAnalytics(orders);



  const getAllFranchises = async () => {
    const response = await getFranchise()

    if (
      response.status === 200 ||
      response.status === 201 ||
      response.status === "success"
    ) {
      setFranchises(response.data || [])
    } else {
      toast.error(response.message || "Failed to fetch franchises")
    }
  }


  useEffect(() => {
    getAllFranchises()
  }, [])


  // Load ECharts from CDN
  useEffect(() => {
    if (window.echarts) { setEchartsLoaded(true); return; }
    const script = document.createElement("script");
    script.src = "https://cdnjs.cloudflare.com/ajax/libs/echarts/5.4.3/echarts.min.js";
    script.onload = () => setEchartsLoaded(true);
    document.head.appendChild(script);
  }, []);

  // Clock
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  // Alerts
  const alerts = useMemo(() => {
    const a = [];
    if (analyticsOverview?.pending?.count > 0) a.push({ icon: "⏰", text: `${analyticsOverview?.pending?.count} orders pending for over 7 days — immediate action required` });
    // if (analytics.noVpp.length > 0) a.push({ icon: "📋", text: `${analytics.noVpp.length} pending orders missing VPP numbers — cannot dispatch` });
    if (parseFloat(analyticsOverview?.returned?.percentage) > 40) a.push({ icon: "↩", text: `Return rate at ${analyticsOverview?.returned?.percentage}% — exceeding 40% threshold, review delivery areas` });
    a.push({ icon: "💰", text: `Total revenue locked in pending orders: PKR ${analyticsOverview?.pending?.amount.toLocaleString()}` });
    // a.push({ icon: "🏙️", text: `Top performing city: ${analytics.byCity[0]?.[0]} with ${analytics.byCity[0]?.[1]} orders` });
    return a;
  }, [analyticsOverview]);

  // Marquee data
  const marqueeItems = useMemo(() => [
    { icon: "📦", label: "Total Orders", value: analytics.total },
    { icon: "✅", label: "Delivered", value: analytics.delivered, color: "#10b981" },
    { icon: "⏳", label: "Pending", value: analytics.pending, color: "#f59e0b" },
    { icon: "↩", label: "Returned", value: analytics.returned, color: "#ef4444" },
    { icon: "💰", label: "Revenue", value: `PKR ${analytics.revenue.toLocaleString()}`, color: "#10b981" },
    { icon: "📊", label: "Delivery Rate", value: `${isNaN(analytics.deliveryRate) ? 0 : analytics.deliveryRate}%`, color: "#6366f1" },
    { icon: "👤", label: "Customers", value: analytics.uniqueCustomers },
    { icon: "🏙️", label: "Top City", value: analytics.byCity[0]?.[0] },
    { icon: "📉", label: "Return Rate", value: `${isNaN(analytics.returnRate) ? 0 : analytics.returnRate}%`, color: "#ef4444" },
    { icon: "💳", label: "Avg Order", value: `PKR ${isNaN(analytics.avgOrderValue) ? 0 : Math.round(analytics.avgOrderValue).toLocaleString()}` },
  ], [analytics]);

  const navItems = ["dashboard", "orders", "analytics", "customers"];
  const [topCustomers, setTopCustomers] = useState([]);
  const [topAgents, setTopAgents] = useState([]);
  const [topCities, setTopCities] = useState([]);


  const fetchAnalytics = async () => {
    try {
      setLoading(true);

      const response = await getAnalyticsOverview(
        companyPinToSend,
        filterType
      );

      if (response?.status === "success") {
        setAnalyticsOverview(response.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };


  const fetchOrderOverview = async () => {
    try {
      setLoading(true);

      const response = await getOrdersOverview(
        companyPinToSend,
        filterType
      );

      if (response?.status === "success") {
        setTopCustomers(response.data.topCustomers || []);
        setTopAgents(response.data.agentPerformance || []);
        setTopCities(response.data.cityAnalytics || []);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (companyPinToSend) {
      fetchOrderOverview();
      fetchAnalytics();
    }
  }, [companyPinToSend, filterType]);

  // if (loading) return <ThemeLoader />;

  const sortedTopCities = useMemo(() => {
    return [...topCities].sort((a, b) => b.revenue - a.revenue);
  }, [topCities]);

  return (
    <>

      {loading && <ThemeLoader />}


      <style>{CSS}</style>
      <div className="dash">
        {/* TOP NAV */}
        <div className="top-nav">
          <div className="top-nav-inner d-none">
            <div className="logo">Dashboard</div>
            <div className="nav-links d-none">
              {navItems.map(n => (
                <div key={n} className={`nav-link${activeNav === n ? " active" : ""}`} onClick={() => setActiveNav(n)}>
                  {n.charAt(0).toUpperCase() + n.slice(1)}
                </div>
              ))}
            </div>
            <div className="top-right">
              <div className="now-badge d-none" >
                <span className="dot-live" />
                {now.toLocaleTimeString()} — {now.toLocaleDateString("en-PK", { weekday: "short", day: "numeric", month: "short", year: "numeric" })}
              </div>
            </div>
          </div>
        </div>

        {/* MARQUEE TICKER */}
        {/* <DataMarquee items={marqueeItems} /> */}

        <div className="dash-inner" style={{ paddingTop: 28 }}>

          {/* PAGE TITLE */}
          <div className="section"
          // style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between" }}
          >
            <div className="row">
              <div className="col">
                <h1 style={{ fontFamily: "'Syne',sans-serif", fontSize: 26, fontWeight: 800, marginBottom: 4 }}>
                  Orders Overview
                </h1>
                <p className="d-none" style={{ fontSize: 14, color: "var(--text-muted)" }}>
                  Complete intelligence dashboard · {orders.length} records · Last updated {new Date(Math.max(...orders.map(o => new Date(o.updatedAt)))).toLocaleDateString()}
                </p>
              </div>

              <div className="col-auto">
                <div className="row g-1">
                  <div className="col">

                    <div>
                      <select
                        style={{ width: "250px", fontSize: "14px" }}
                        value={filterType}
                        onChange={(e) => setFilterType(e.target.value)}
                        className="oms-select-dark form-select border-0  "
                      >
                        <option value="">All Time</option>
                        <option value="today">This Day</option>
                        <option value="week">This Week</option>
                        <option value="month">This Month</option>
                        <option value="year">This Year</option>
                      </select>
                    </div>
                  </div>
                  <div className="col">


                    {role === "superAdmin" && (

                      <div>
                        <select
                          style={{ width: "250px", fontSize: "14px" }}
                          value={company || ""} // ✅ fallback
                          onChange={(e) => setCompany(e.target.value)}
                          className="oms-select-dark form-select border-0 "
                        >
                          {/* ✅ default option */}
                          <option selected disabled value="">Select Company</option>

                          {Array.isArray(franchises) && franchises.length > 0 &&
                            franchises.map((franchise, i) => (
                              <option
                                key={franchise?.id || i}
                                value={franchise?.company_pin || ""}
                              >
                                {franchise?.company_name || "Unnamed"}
                              </option>
                            ))
                          }
                        </select>
                      </div>
                    )}
                  </div>
                </div>

              </div>

            </div>
            <div className="d-none" style={{ display: "flex", gap: 8 }}>
              <div style={{ padding: "8px 16px", background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 8, fontSize: 12, color: "var(--text-muted)", cursor: "pointer" }}>
                ⬇ Export Report
              </div>
              <div style={{ padding: "8px 16px", background: "var(--accent)", borderRadius: 8, fontSize: 12, color: "#fff", cursor: "pointer", fontWeight: 600 }}>
                ➕ New Order
              </div>
            </div>
          </div>

          {/* ALERT TICKER */}
          {alerts.length > 0 && (
            <div className="section">
              <AlertTicker alerts={alerts} />
            </div>
          )}

          {/* ── KPI TILES ── */}
          <div className="section d-none">
            <div className="grid-4">
              <KPITile icon="📦" label="Total Orders" value={analytics.total} color="#6366f1" sub="All time records" trend={8} delay={0} />
              <KPITile icon="✅" label="Delivered" value={analytics.delivered} color="#10b981" sub={`PKR ${analytics.revenue.toLocaleString()} collected`} trend={12} delay={80} />
              <KPITile icon="⏳" label="Pending" value={analytics.pending} color="#f59e0b" sub={`${analytics.stalePending.length} overdue 7d+`} trend={-5} delay={160} />
              <KPITile icon="↩" label="Returned" value={analytics.returned} color="#ef4444" sub={`${analytics.returnRate}% return rate`} trend={-3} delay={240} />
            </div>
          </div>

          <div className="section d-none">
            <div className="grid-4">
              <KPITile icon="💰" label="Total Revenue" value={analytics.totalRevenue} prefix="PKR " color="#10b981" sub="Incl. pending COD" trend={6} decimals={0} delay={0} />
              <KPITile icon="👤" label="Unique Customers" value={analytics.uniqueCustomers} color="#8b5cf6" sub="Distinct buyers" delay={80} />
              <KPITile icon="🛍" label="Avg Order Value" value={analytics.avgOrderValue} prefix="PKR " color="#f59e0b" sub="Per transaction" decimals={0} delay={160} />
              <KPITile icon="🏙️" label="Cities Served" value={analytics.byCity.length} color="#06b6d4" sub={`Top: ${analytics.byCity[0]?.[0]}`} delay={240} />
            </div>
          </div>



          {/* ── WEEKLY + PRODUCT ── */}
          {/* <div className="section">
            <div className="grid-2">
              <Card>
                <SectionTitle sub="Weekly order volume and revenue trend">Weekly Performance</SectionTitle>
                {echartsLoaded && <WeeklyBarChart data={analytics.weeklyTrend} />}
              </Card>
              <Card>
                <SectionTitle sub="Orders by article/product type">Product Mix</SectionTitle>
                {echartsLoaded && <ProductPieChart data={analytics.byProduct} />}
                <div style={{ marginTop: 10 }}>
                  {analytics.byProduct.slice(0, 4).map(([prod, cnt], i) => (
                    <ProgressBar key={prod} label={prod} value={cnt} max={analytics.total}
                      color={["#6366f1", "#10b981", "#f59e0b", "#8b5cf6"][i]} />
                  ))}
                </div>
              </Card>
            </div>
          </div> */}


          {/* ── RADAR + KPI CARDS ── */}
          <div className="section d-none">
            <div className="grid-3">
              {/* <Card className="d-none">
                <SectionTitle sub="Order distribution across top 5 cities">City Radar</SectionTitle>
                {echartsLoaded && <ReturnRateRadar data={analytics.byCity} />}
              </Card> */}

              {/* KPI Scorecard */}
              <Card style={{ gridColumn: "span 3" }}>
                <SectionTitle sub="Key performance indicators and health metrics">Business Health Score</SectionTitle>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 14 }}>
                  {[
                    { icon: "🎯", label: "Fill Rate", value: `${analytics.deliveryRate}%`, color: parseFloat(analytics.deliveryRate) > 40 ? "#10b981" : "#ef4444", note: "Target: 40%+" },
                    { icon: "📦", label: "Order Velocity", value: `${(analytics.total / 7).toFixed(1)}/day`, color: "#6366f1", note: "Avg orders/day" },
                    { icon: "💵", label: "Revenue/Order", value: `PKR ${Math.round(analytics.avgOrderValue).toLocaleString()}`, color: "#f59e0b", note: "Average ticket size" },
                    { icon: "📉", label: "Return Rate", value: `${analytics.returnRate}%`, color: parseFloat(analytics.returnRate) > 40 ? "#ef4444" : "#f59e0b", note: "Target: <30%" },
                    { icon: "🚀", label: "VPP Coverage", value: `${Math.round((orders.filter(o => o.VppNumber).length / analytics.total) * 100)}%`, color: "#8b5cf6", note: "Orders with VPP" },
                    { icon: "⚡", label: "Pending Backlog", value: analytics.pending, color: "#f59e0b", note: analytics.stalePending.length > 0 ? `${analytics.stalePending.length} overdue` : "On track" },
                  ].map(k => (
                    <div key={k.label} style={{ background: "var(--surface2)", borderRadius: 10, padding: "14px 16px", borderLeft: `3px solid ${k.color}` }}>
                      <div style={{ fontSize: 20, marginBottom: 8 }}>{k.icon}</div>
                      <div style={{ fontFamily: "'Syne',sans-serif", fontSize: 20, fontWeight: 800, color: k.color, marginBottom: 2 }}>{k.value}</div>
                      <div style={{ fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1, color: "var(--text-muted)", marginBottom: 2 }}>{k.label}</div>
                      <div style={{ fontSize: 11, color: "var(--text-muted)", opacity: 0.7 }}>{k.note}</div>
                    </div>
                  ))}
                </div>
              </Card>
            </div>
          </div>

          {/* ── TOP CUSTOMERS TABLE ── */}
          <div className="section">
            <div className="grid-2">
              <Card>
                <SectionTitle sub="Customers ranked by total order value">Top Customers</SectionTitle>
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Customer</th>
                      <th>Orders</th>
                      <th>Delivered</th>
                      <th>Returned</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(topCustomers) && topCustomers.length > 0 ? (
                      topCustomers.map((c, i) => {
                        return (
                          <tr key={c.id || i}>
                            <td>
                              <div
                                className={`rank ${i === 0 ? "gold" : i === 1 ? "silver" : i === 2 ? "bronze" : ""
                                  }`}
                              >
                                {i + 1}
                              </div>
                            </td>

                            <td style={{ fontWeight: 500, textTransform: "capitalize" }}>
                              {c.customerName}
                            </td>

                            <td>
                              <span
                                style={{
                                  fontFamily: "'Syne',sans-serif",
                                  fontWeight: 700,
                                  color: "var(--accent)",
                                }}
                              >
                                {c.totalOrders}
                              </span>
                            </td>

                            <td>
                              <span
                                className="badge"
                                style={{
                                  background: "rgba(16,185,129,0.12)",
                                  color: "#10b981",
                                }}
                              >
                                ✓ {c.deliveredOrders}
                              </span>
                            </td>

                            <td>
                              <span
                                className="badge"
                                style={{
                                  background: "rgba(239, 68, 68, 0.12)",
                                  color: "rgb(239, 68, 68)",
                                }}
                              >
                                ✘ {c.returnedOrders}
                              </span>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={5} style={{ textAlign: "center" }}>
                          No customers found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Card>

              {/* Agent Performance */}
              <Card >
                <SectionTitle sub="Booking agents ranked by order count">Agent Performance</SectionTitle>
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Agent</th>
                      <th>Orders</th>
                      <th>Delivered</th>
                      <th>Returned</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(topAgents) && topAgents.length > 0 ? (
                      topAgents.map((ag, i) => (
                        <tr key={ag.id || i}>
                          <td>
                            <div
                              className={`rank ${i === 0 ? "gold" : i === 1 ? "silver" : i === 2 ? "bronze" : ""
                                }`}
                            >
                              {i + 1}
                            </div>
                          </td>

                          <td style={{ fontWeight: 500 }}>{ag.bookingAgent}</td>

                          <td>
                            <span
                              style={{
                                fontFamily: "'Syne',sans-serif",
                                fontWeight: 700,
                                color: "var(--accent)"
                              }}
                            >
                              {ag.totalOrders}
                            </span>
                          </td>

                          <td>
                            <span
                              className="badge"
                              style={{
                                background: "rgba(16,185,129,0.12)",
                                color: "#10b981"
                              }}
                            >
                              ✓ {ag.deliveredOrders}
                            </span>
                          </td>

                          <td>
                            <span
                              className="badge"
                              style={{
                                background: "rgba(239, 68, 68, 0.12)",
                                color: "rgb(239, 68, 68)"
                              }}
                            >
                              ✘ {ag.returnedOrders}
                            </span>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={5} style={{ textAlign: "center" }}>
                          No agents found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Card>
            </div>
          </div>


          {/* ── CITY CHARTS ── */}
          <div className="section">
            <div className="grid-2">
              <Card>
                <SectionTitle sub="Number of orders shipped to each city">Orders by City</SectionTitle>
                {echartsLoaded && <CityBarChart data={topCities} />}
              </Card>
              <Card>
                <SectionTitle sub="Total order value (PKR) by city">Revenue by City</SectionTitle>
                {echartsLoaded && <RevenueCityChart
                  data={sortedTopCities}
                />}
              </Card>
            </div>
          </div>

          {/* ── ALERTS PANEL + PENDING TABLE ── */}
          <div className="section d-none">
            <div className="grid-2">
              {/* Alerts panel */}
              <Card style={{ borderColor: "rgba(239,68,68,0.2)" }}>
                <SectionTitle sub="Issues requiring immediate attention">
                  <span style={{ color: "#ef4444" }}>⚠</span> Action Required
                </SectionTitle>

                {analytics.stalePending.length > 0 && (
                  <div style={{ marginBottom: 16 }}>
                    <div style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: 1, color: "var(--text-muted)", marginBottom: 8, fontWeight: 600 }}>Overdue Pending Orders</div>
                    {analytics.stalePending.slice(0, 4).map(o => (
                      <div className="alert-row" key={o.id}>
                        <span style={{ fontSize: 14 }}>⏰</span>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: 600, color: "var(--text)", fontSize: 12 }}>{o.trackingId} · {o.customerName}</div>
                          <div style={{ color: "var(--text-muted)", fontSize: 11 }}>{o.city} · Placed {new Date(o.createdAt).toLocaleDateString()}</div>
                        </div>
                        <span className="badge" style={{ background: "rgba(245,158,11,0.12)", color: "#f59e0b", fontSize: 10 }}>OVERDUE</span>
                      </div>
                    ))}
                  </div>
                )}

                {analytics.noVpp.length > 0 && (
                  <div>
                    <div style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: 1, color: "var(--text-muted)", marginBottom: 8, fontWeight: 600 }}>Missing VPP Numbers</div>
                    {analytics.noVpp.slice(0, 3).map(o => (
                      <div className="alert-row" key={o.id} style={{ background: "rgba(245,158,11,0.07)", borderColor: "rgba(245,158,11,0.2)" }}>
                        <span style={{ fontSize: 14 }}>📋</span>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: 600, color: "var(--text)", fontSize: 12 }}>{o.trackingId} · {o.customerName}</div>
                          <div style={{ color: "var(--text-muted)", fontSize: 11 }}>VPP not assigned · Amount: PKR {parseInt(o.amount).toLocaleString()}</div>
                        </div>
                        <span className="badge" style={{ background: "rgba(245,158,11,0.12)", color: "#f59e0b", fontSize: 10 }}>NO VPP</span>
                      </div>
                    ))}
                  </div>
                )}

                {/* Summary recommendations */}
                <div style={{ marginTop: 16, padding: "12px 14px", background: "rgba(99,102,241,0.08)", borderRadius: 8, border: "1px solid rgba(99,102,241,0.2)" }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: "var(--accent)", marginBottom: 6 }}>💡 Recommendations</div>
                  <ul style={{ paddingLeft: 16, fontSize: 12, color: "var(--text-muted)", lineHeight: 1.9 }}>
                    {parseFloat(analytics.returnRate) > 40 && <li>Return rate is high — investigate delivery failures in top returned cities</li>}
                    {analytics.noVpp.length > 0 && <li>Assign VPP numbers to {analytics.noVpp.length} pending orders before dispatch</li>}
                    {analytics.stalePending.length > 0 && <li>Follow up on {analytics.stalePending.length} overdue pending orders immediately</li>}
                    <li>Focus acquisition on {analytics.byCity[0]?.[0]} — highest order volume city</li>
                    <li>Phone channel drives {analytics.bySource.find(s => s[0] === "phone")?.[1] || 0} orders — prioritize phone team</li>
                  </ul>
                </div>
              </Card>

              {/* Recent orders */}
              <Card>
                <SectionTitle sub="Most recently created orders">Recent Orders</SectionTitle>
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>Tracking</th>
                      <th>Customer</th>
                      <th>City</th>
                      <th>Amount</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.slice(0, 10).map(o => {
                      const st = STATUS_CFG[o.status] || STATUS_CFG.pending;
                      return (
                        <tr key={o.id}>
                          <td style={{ fontFamily: "'Syne',sans-serif", fontSize: 11, fontWeight: 700, color: "var(--accent)" }}>{o.trackingId}</td>
                          <td style={{ fontWeight: 500, fontSize: 12, textTransform: "capitalize" }}>{o.customerName}</td>
                          <td style={{ fontSize: 11, color: "var(--text-muted)" }}>{o.city || "—"}</td>
                          <td style={{ fontFamily: "'Syne',sans-serif", fontWeight: 700, color: "#10b981", fontSize: 13 }}>₨{parseInt(o.amount).toLocaleString()}</td>
                          <td>
                            <span className="badge" style={{ background: st.bg, color: st.color }}>
                              {st.icon} {st.label}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Card>
            </div>
          </div>

          {/* ── CITY DISTRIBUTION FULL WIDTH ── */}
          <div className="section">
            <Card>
              <SectionTitle sub="Customer spread across all served cities">City-wise Customer Distribution</SectionTitle>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(180px,1fr))", gap: 12, marginTop: 8 }}>
                {topCities?.map((item, i) => {
                  const pct = Number(item.percentage || 0);

                  const colors = [
                    "#6366f1",
                    "#10b981",
                    "#f59e0b",
                    "#ef4444",
                    "#8b5cf6",
                    "#06b6d4",
                    "#ec4899",
                    "#84cc16",
                  ];

                  const c = colors[i % colors.length];

                  return (
                    <div
                      key={item.city || i}
                      style={{
                        background: "var(--surface2)",
                        borderRadius: 10,
                        padding: "14px 16px",
                        borderTop: `2px solid ${c}`,
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          bottom: -10,
                          right: -10,
                          width: 60,
                          height: 60,
                          borderRadius: "50%",
                          background: c,
                          opacity: 0.06,
                          filter: "blur(10px)",
                        }}
                      />

                      {/* Orders */}
                      <div style={{ fontSize: 22, fontWeight: 800, color: c }}>
                        {item.totalOrders}
                      </div>

                      {/* City */}
                      <div
                        style={{
                          fontSize: 12,
                          fontWeight: 600,
                          color: "var(--text-dim)",
                          marginTop: 2,
                          marginBottom: 8,
                        }}
                      >
                        {item.city}
                      </div>

                      {/* Progress bar */}
                      <div
                        style={{
                          height: 4,
                          background: "rgba(255,255,255,0.06)",
                          borderRadius: 4,
                        }}
                      >
                        <div
                          style={{
                            height: "100%",
                            width: `${pct}%`,
                            background: c,
                            borderRadius: 4,
                          }}
                        />
                      </div>

                      {/* Percentage */}
                      <div
                        style={{
                          fontSize: 10,
                          color: "var(--text-muted)",
                          marginTop: 4,
                        }}
                      >
                        {pct}% of total
                      </div>
                    </div>
                  );
                })}
              </div>
            </Card>
          </div>

          {/* ── FOOTER ── */}
          <div className="d-none" style={{ textAlign: "center", padding: "20px 0 10px", borderTop: "1px solid var(--border)", color: "var(--text-muted)", fontSize: 12 }}>
            ARC.OMS Analytics Dashboard · {orders.length} orders loaded · Data updates reflect real order records
          </div>

        </div >
      </div >
    </>
  );
}
